//引入Vue
import Vue from "vue";
//引入App
import App from './App';
//引入element插件库
import ElementUI from 'element-ui';
//引入element的全部样式
import 'element-ui/lib/theme-chalk/index.css';
//引入vue-router
import VueRouter from "vue-router";
import router from './router';
//引入Vuex
import store from './store/index.js'
//引入boostrap 样式 和 js
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap.js'
//引入MuiPlayer插件
import 'mui-player/dist/mui-player.min.css'
import MuiPlayer from 'mui-player'
/* 引入dayjs */
import dayjs from "dayjs"
Vue.prototype.dayjs = dayjs;//可以全局使用dayjs
/* 引入axios */
import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'        //关键代码
Vue.prototype.HOST = '/api';
/* 引入echart */
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;
/* 引入view.ui */
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

import mavonEditor from 'mavon-editor' // components
import 'mavon-editor/dist/css/index.css' // styles

import Constant from "./constant/Index"; // 引入所有url
Vue.use(mavonEditor)

//关闭Vue的生产提示
Vue.config.productionTip = false;
//引用element插件
Vue.use(ElementUI);
//应用vue-router插件
Vue.use(VueRouter);

Vue.use(Constant);

/* 使用view */
Vue.use(ViewUI);
/* 实现跳转页面自动置顶 */
// router.afterEach((to,from,next) => {
//     window.scrollTo(0,0);
// })



new Vue({
    el: '#app',
    render: h => h(App),
    router,
    store: store,
});